import { deleteJSON, fetchJSON, postJSON, putJSON } from 'api/fetch';

import {
  acceptTradeCoverRequestApiRoute,
  approveClaimRequestApiRoute,
  approveRejectAndUpdateAvailabilityApiRoute,
  ApproveRejectAndUpdateAvailabilityParams,
  approveTimeOffRequestApiRoute,
  approveTradeCoverRequestApiRoute,
  deleteAvailabilityTemplateApiRoute,
  deleteTimeOffRequestApiRoute,
  getCoverRequestDetailsApiRoute,
  getOpenShiftDetailsApiRoute,
  getRequestDetailsApiRoute,
  getRequestsFeedApiRoute,
  GetRequestsFeedApiRouteParams,
  getTimeOffRequestDetailsApiRoute,
  markTabViewedApiRoute,
  MarkTabViewedApiRouteParams,
  rejectTimeOffRequestApiRoute,
  rejectTradeCoverRequestApiRoute,
} from './apiRoutes';

// ============================================================================
// Requests Feed API
// ============================================================================

export const getRequestsFeed = async ({
  tab,
  locationId,
  cursor: nextCursor,
  limit,
}: GetRequestsFeedApiRouteParams) => {
  const res = await fetchJSON(
    getRequestsFeedApiRoute({ tab, locationId, cursor: nextCursor, limit })
  );

  const { requests, cursor, unread_counts } = await res;

  return { requests, cursor, unreadCounts: unread_counts };
};

export const markTabViewed = async ({
  tab,
  locationId,
}: MarkTabViewedApiRouteParams) => {
  const payload: { tab: string; location_id?: string } = {
    tab,
  };

  if (locationId) {
    payload.location_id = locationId;
  }

  const res = await postJSON(markTabViewedApiRoute(), payload);
  const { last_viewed_at, unread_counts } = await res;

  return {
    lastViewedAt: last_viewed_at,
    unreadCounts: unread_counts,
  };
};

// ============================================================================
// Availability API
// ============================================================================

export const approveRejectAndUpdateAvailability = async ({
  templateId,
  status,
}: ApproveRejectAndUpdateAvailabilityParams) => {
  const payload = {
    availability_template: {
      status,
    },
  };

  return putJSON(
    approveRejectAndUpdateAvailabilityApiRoute({ templateId }),
    payload
  );
};

export const deleteAvailabilityTemplate = async (templateId: string) =>
  deleteJSON(deleteAvailabilityTemplateApiRoute(templateId));

// ============================================================================
// Trade/Cover Requests API
// ============================================================================

export const getRequestDetails = async (
  requestId: string,
  tab: string = 'my'
) => {
  const res = await fetchJSON(getRequestDetailsApiRoute(requestId, tab));
  return res;
};

export const getCoverRequestDetails = async (requestId: string) =>
  fetchJSON(getCoverRequestDetailsApiRoute(requestId));

export const approveTradeCoverRequest = async (requestId: string) =>
  putJSON(approveTradeCoverRequestApiRoute(requestId));

export const rejectTradeCoverRequest = async (responderItemId: string) =>
  putJSON(rejectTradeCoverRequestApiRoute(responderItemId));

export const acceptTradeCoverRequest = async (responderItemId: string) =>
  putJSON(acceptTradeCoverRequestApiRoute(responderItemId));

// ============================================================================
// Time Off Requests API
// ============================================================================

export const getTimeOffRequestDetails = async (requestId: string) =>
  fetchJSON(getTimeOffRequestDetailsApiRoute(requestId));

export const approveTimeOffRequest = async (requestId: string) =>
  putJSON(approveTimeOffRequestApiRoute(requestId));

export const rejectTimeOffRequest = async (requestId: string) =>
  putJSON(rejectTimeOffRequestApiRoute(requestId));

export const deleteTimeOffRequest = async (requestId: string) =>
  deleteJSON(deleteTimeOffRequestApiRoute(requestId));

// ============================================================================
// Open Shifts API
// ============================================================================

export const getOpenShiftDetails = async (requestId: string) =>
  fetchJSON(getOpenShiftDetailsApiRoute(requestId));

export const approveClaimRequest = async (requestId: string) =>
  putJSON(approveClaimRequestApiRoute(requestId));
